import { useDispatch } from "react-redux";
import { TokenLoginParam } from "../types/token";
import { default as tokenService } from "../services/token";
import { defineToken, undefineToken } from "../utils/token";
import { loginFailure, loginRequest, loginSuccess } from "../actions";
import { AxiosError } from "axios";
import { useSearchParams } from "react-router";
import cookiesUtils from "@/utils/cookies";
import useLangs from "@/languages/hooks/useLangs";

const useToken = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { changeLang, getBCP47Lang } = useLangs();

  const removeSearchParams = () => {
    const tokenParam = searchParams.get('token');

    if (tokenParam) {
      // Delete each query param
      searchParams.delete('token');

      // Update state after
      setSearchParams(searchParams);
    }
  };

  const loginToken = ({token}: TokenLoginParam) => {
    cookiesUtils.acceptConsentCookies();
    removeSearchParams();

    dispatch(loginRequest("TOKEN"));
    undefineToken();

    tokenService.validateToken({token})
      .then((res) => {
          const {locale} = defineToken(token);
          if (locale) {
            changeLang(getBCP47Lang(locale));
          }
          dispatch(loginSuccess());
      }).catch((err: AxiosError) => {
        undefineToken();

        // TODO this should not default to a 401 error
        dispatch(loginFailure({
          statusCode: 401,
          status: "error"
        }));
      });
  };

  return {
    loginToken
  }
};

export default useToken;
